import { QueryClient, useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  WorkspaceQuizLock,
  getWorkspaceQuizLock,
} from '../../../api/workspaces/lock';

const WORKSPACE_QUIZ_LOCK_STALE_TIME = 10 * 1000; // 10 seconds

interface UseWorkspaceQuizLockParams {
  workspaceId: string;
  workspaceQuizId: string;
}

export function useWorkspaceQuizLock<T = WorkspaceQuizLock>({
  workspaceId,
  workspaceQuizId,
}: UseWorkspaceQuizLockParams) {
  return useQuery<
    WorkspaceQuizLock,
    unknown,
    T,
    ReturnType<typeof workspaceKeys.quizLock>
  >({
    queryKey: workspaceKeys.quizLock({
      workspaceId,
      workspaceQuizId,
    }),
    queryFn: () =>
      getWorkspaceQuizLock({ workspaceId, workspaceQuizId: workspaceQuizId }),
    staleTime: WORKSPACE_QUIZ_LOCK_STALE_TIME,
    retry: false,
  });
}

interface RefetchWorkspaceQuizLockParams {
  workspaceQuizId: string;
  workspaceId: string;
  queryClient: QueryClient;
}

export function refetchWorkspaceQuizLock({
  workspaceQuizId,
  workspaceId,
  queryClient,
}: RefetchWorkspaceQuizLockParams) {
  return queryClient.refetchQueries(
    workspaceKeys.quizLock({ workspaceId, workspaceQuizId }),
    { exact: true, fetchStatus: 'fetching' },
    { cancelRefetch: true }
  );
}
